import React, { Component } from 'react'
import JewelryPanel from '../jewelry-panel'
import SelectItem from '../../../components/select-item'
import Spacer from '../../../components/spacer'
import { showBasketTypePanel } from '../../../utils/jewelry-validation'

class BasketTypePanel extends Component {
  render () {
    const props = this.props
    const getBasketTypeOptions = () => {
      let disableStandardSolitarie = props => props.shapes[0] !== 'round' && props.shapes[0] !== 'princess'
      return [
        {value: 'standard_solitaire', label: 'Standard Solitaire', disabled: disableStandardSolitarie(props)},
        {value: 'custom', label: 'Custom'}
      ]
    }
    return (
      <JewelryPanel
        id='basketTypePanel'
        show={showBasketTypePanel(props)}
        isResetting={props.isResetting}>

        <Spacer lg />

        <SelectItem
          id='basketType'
          label='Basket Type'
          labelId='basket_type'
          options={getBasketTypeOptions()}
          value={props.basket_type}
          onChange={props.onChangeVal.bind(this, 'basket_type')}
          initVal={null}
        />
      </JewelryPanel>
    )
  }
}

export default BasketTypePanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/basket-type-panel/index.js